"use client";

import { c as _c } from "react/compiler-runtime";
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import LocationSvg from 'src/components/svg/LocationSvg';
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import classNames from 'classnames';
import styles from './LocationResult.module.css';

//#region [Props]
type LocationResultProps = {
  locationName: string;
  className?: string;
  onClick: (event: React.MouseEvent) => void;
  forceHardlinks?: boolean;
};
//#endregion

//#region [Component]
export default function LocationResult(t0) {
  const $ = _c(15);
  const {
    locationName,
    onClick,
    className,
    forceHardlinks: t1
  } = t0;
  const forceHardlinks = t1 === undefined ? false : t1;
  const locationContext = useLocationContext();
  const t2 = `/program?location=${locationName}`;
  let t3;
  if ($[0] !== className) {
    t3 = classNames(styles.SLocationResult, className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== locationContext || $[3] !== locationName || $[4] !== onClick) {
    t4 = e => {
      onClick(e);
      locationContext.setLocation([locationName]);
    };
    $[2] = locationContext;
    $[3] = locationName;
    $[4] = onClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.SLocationIcon}><LocationSvg className={styles.SLocationSvg} /></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== locationName) {
    t6 = <div className={styles.SLocationName}>{locationName}</div>;
    $[7] = locationName;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== forceHardlinks || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t6) {
    t7 = <FilmwebLink to={t2} className={t3} onClick={t4} hardLink={forceHardlinks}>{t5}{t6}</FilmwebLink>;
    $[9] = forceHardlinks;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
//#endregion